
<div class="row">
  <h3 class="col">Distribuição de limites - Ciclo #{{ciclo()?.numero}}</h3>
  <div class="col-auto">
    <button class="btn btn-primary" (click)="voltar()">Voltar</button>
  </div>
</div>

@if (ciclo(); as cicloDetalhes) {
  <div class="container">
    <div class="row mb-3">
      <div class="col-3">
        <label><b>Número</b></label>
        <input type="text" class="form-control" [value]="cicloDetalhes.numero" disabled>
      </div>
      <div class="col-3">
        <label><b>Tranche</b></label>
        <input type="text" class="form-control" [value]="cicloDetalhes.numeroTranche" disabled>
      </div>
      <div class="col-3">
        <label><b>Ignora Metas</b></label>
        <input type="checkbox" class="form-check checkbox-gigante" [ngModel]="cicloDetalhes.ignoraMetas" disabled>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-3">
        <label><b>Data de Início</b></label>
        <input type="text" class="form-control" [value]="cicloDetalhes.dataInicio | date: 'dd/MM/yyyy'" disabled>
      </div>
      <div class="col-3">
        <label><b>Data de Fim</b></label>
        <input type="text" class="form-control" [value]="cicloDetalhes.dataFim | date: 'dd/MM/yyyy'" disabled>
      </div>
      <div class="col-3">
        <label><b>Data Referencia Excepcionalizado</b></label>
        <input type="text" class="form-control" [value]="cicloDetalhes.dataReferenciaCicloExcepcionalizado | date: 'dd/MM/yyyy'" disabled>
      </div>
      <div class="col-3">
        <label><b>Data de Criação</b></label>
        <input type="text" class="form-control" [value]="cicloDetalhes.dataCriacao | date: 'dd/MM/yyyy HH:mm:ss'" disabled>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-3">
        <label><b>Valor do Aporte</b></label>
        <input type="text" class="form-control" [ngModel]="cicloDetalhes.valorAporte" bnMask="MOEDA" disabled>
      </div>
      <div class="col-3">
        <label><b>% Meta 1 primeira distribuição</b></label>
        <input type="text" class="form-control" [value]="cicloDetalhes.valorPercentualMinimoMeta1PrimeiraDistribuicao" 
        bnMask="DECIMAL" casasDecimais="2" disabled>
      </div>
      <div class="col-3">
        <label><b>% Meta 2 primeira distribuição</b></label>
        <input type="text" class="form-control" [value]="cicloDetalhes.valorPercentualMinimoMeta2PrimeiraDistribuicao" 
        bnMask="DECIMAL" casasDecimais="2" disabled>
      </div>
      <div class="col-3">
        <label><b>% Redução meta 2</b></label>
        <input type="text" class="form-control" [value]="cicloDetalhes.valorPercentualReducaoNaoCumprimentoMeta2PrimeiraDistribuicao" 
        bnMask="DECIMAL" casasDecimais="2" disabled>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-3">
        <label><b>% Meta 3 primeira distribuição</b></label>
        <input type="text" class="form-control" [value]="cicloDetalhes.valorPercentualMinimoMeta3PrimeiraDistribuicao" 
        bnMask="DECIMAL" casasDecimais="2" disabled>
      </div>
      <div class="col-3">
        <label><b>% Meta 4 primeira distribuição</b></label>
        <input type="text" class="form-control" [value]="cicloDetalhes.valorPercentualMinimoMeta4PrimeiraDistribuicao || ''" 
        bnMask="DECIMAL" casasDecimais="2" disabled>
      </div>
      <div class="col-3">
        <label><b>% Meta segunda distribuição</b></label>
        <input type="text" class="form-control" [value]="cicloDetalhes.valorPercentualMinimoMetaSegundaDistribuicao" 
        bnMask="DECIMAL" casasDecimais="2" disabled>
      </div>
      <div class="col-3">
        <label><b>% Meta terceira distribuição</b></label>
        <input type="text" class="form-control" [value]="cicloDetalhes.valorPercentualMinimoMetaTerceiraDistribuicao" 
        bnMask="DECIMAL" casasDecimais="2" disabled>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-3">
        <label><b>Valor Total Renúncia</b></label>
        <input type="text" class="form-control"  [ngModel]="cicloDetalhes.valorTotalRenunciaAgentesNoCiclo ?? ''"
        bnMask="MOEDA" disabled>
      </div>
      <div class="col-3">
        <label><b>Valor Renúncia Direcionada</b></label>
        <input type="text" class="form-control" [ngModel]="cicloDetalhes.valorRenunciaDirecionadaAgentesNoCiclo ?? ''" 
        bnMask="MOEDA" disabled>
      </div>
      <div class="col-3">
        <label><b>Valor Renúncia Distribuição</b></label>
        <input type="text" class="form-control" [ngModel]="cicloDetalhes.valorRenunciaParaDistribuicaoTodosAgentesNoCiclo ?? ''" 
        bnMask="MOEDA" disabled>
      </div>
      <div class="col-3">
        <label><b>Valor Total Renúncia distribuído</b></label>
        <input type="text" class="form-control" [ngModel]="cicloDetalhes.valorTotalRenunciaSerDistribuidoNoPeriodo ?? ''" bnMask="MOEDA" disabled>
      </div>
    </div>
    <div class="row mb-1">
      <app-distribuicao-agentes [idCiclo]="cicloDetalhes.id"></app-distribuicao-agentes>
    </div>
  </div>
}